import React, {useState} from 'react';
import {FormattedMessage} from "react-intl";
import {useNavigate} from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './CreateYourContest.style.scss';
import useDeviceType from "../../hooks/useDeviceType";

const CreateYourContest = () => {

    const {isDesktop} = useDeviceType();

    return (
        isDesktop ? <CreateYourContestDesktop/> : <CreateYourContestMobile/>
    )
}

const CreateYourContestMobile = () => {
    const navigate = useNavigate();

        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true
        };

    return(
        <div className="CreateYourContestMobile">

            <div className="slider-container stepContainer">
                <div className='title gold-gradient-text'><FormattedMessage id={'landingPage.whatIsPickX.title'}/></div>

                <Slider {...settings}>
                    <div className="slide1">
                        <div className='step _1'>
                            <div className='number'>1</div>
                            <div className='stepText'>
                                <FormattedMessage id={'landingPage.whatIsPickX.step1'}/>
                            </div>
                        </div>
                        <div className="stepImg _1"/>
                    </div>
                    <div className="slide2">
                        <div className='step _2'>
                            <div className='number'>2</div>
                            <div className='stepText'>
                                <FormattedMessage id={'landingPage.whatIsPickX.step2'}/>
                            </div>
                        </div>
                        <div className="stepImg _2"/>
                    </div>
                    <div className="slide3">
                        <div className='step _3'>
                            <div className='number'>3</div>
                            <div className='stepText'>
                                <FormattedMessage id={'landingPage.whatIsPickX.step3'}/>
                            </div>
                        </div>
                        <div className="stepImg _3"/>
                    </div>

                </Slider>
                <button className='yourPicksButton' onClick={() => {
                    navigate('/lobby')
                    window.scrollTo(0, 0);
                }}>
                    <FormattedMessage id={'landingPage.whatIsPickX.makeYourPicks'}/>
                </button>
            </div>
        </div>
    )
}

const CreateYourContestDesktop = () => {
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(1);

    const Step = ({step})=> {

        const isActive = activeStep ===step;

        return <div className={`step _${step} ${isActive ? "active gold-background" : ""}`}
                    onMouseEnter={e => {
            e.preventDefault();
            setActiveStep(step)
        }}>
            <div className={'number ' + (isActive ? "gold-background" : "")}>{step}</div>
            <div className='stepText'>
                <FormattedMessage id={'landingPage.whatIsPickX.step'+ step}/>
            </div>
        </div>
    }

    return (
        <div className="CreateYourContestDesktop">

            <div className={`stepsImages _${activeStep}`}/>
            <div className='stepsContent'>
                <div className='title gold-gradient-text'><FormattedMessage id={'landingPage.whatIsPickX.title'}/></div>
                <Step step={1} />
                <Step step={2} />
                <Step step={3} />
                <button className='yourPicksButton' onClick={() => {
                    navigate('/lobby')
                }}>
                    <FormattedMessage id={'landingPage.whatIsPickX.makeYourPicks'}/>
                </button>
            </div>
        </div>
    )
}

export default CreateYourContest;